import * as React from "react";
import { createStyles, Theme, WithStyles, withStyles } from "@material-ui/core";
import { DASHBOARD_TYPES, MAIN_TYPES } from "../constants/constants";
import ScreeningDashBoard from "../dashboard/ScreeningDashBoard";
import GenericDashboard from "../dashboard/GenericDashboard";
import PreUseInspectionDashboard from "../dashboard/PreUseInspectionDashboard";
import WorkflowInspectionDashboard from "../dashboard/WorkflowInspectionDashboard";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    menuHideButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "none",
      },
    },
    menuShowButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "visible",
      },
      color: "black",
    },
    extendedIcon: {
      marginRight: theme.spacing(1),
    },
    sectionDesktop: {
      display: "none",
      [theme.breakpoints.up("md")]: {
        display: "flex",
      },
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      paddingTop: 0,
      paddingBottom: 8,
      minHeight: 64,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    large: {
      margin: 10,
      width: theme.spacing(15),
      height: theme.spacing(15),
    },
  });

interface Props extends WithStyles<typeof styles> {
  profileData: any;
  onLogOut: any;
  location?: any;
  properties?: any;
}
class MainDashboard extends React.Component<Props> {
  componentDidMount = () => { };

  getDashboard = () => {
    if (!this.props.location) {
      return null;
    }
    if (!this.props.location.state) {
      return null;
    }
    const { properties } = this.props.location.state;
    if (!properties) {
      return null;
    }
    switch (properties.inspectionType.value) {
      case MAIN_TYPES.AUDIT: {
        if (
          properties.inspectionType.label.toLowerCase().includes("personal")
        ) {
          return (
            //@ts-ignore
            <ScreeningDashBoard
              location={this.props.location}
              profileData={this.props.profileData}
              onLogOut={this.props.onLogOut}
            />
          );
        } else {
          return (
            //@ts-ignore
            <GenericDashboard
              location={this.props.location}
              profileData={this.props.profileData}
              onLogOut={this.props.onLogOut}
              properties={properties}
            />
          );
        }
      }
      case MAIN_TYPES.PERSONAL: {
        if (
          properties.inspectionType.label.toLowerCase().includes("personal")
        ) {
          return (
            //@ts-ignore
            <ScreeningDashBoard
              location={this.props.location}
              profileData={this.props.profileData}
              onLogOut={this.props.onLogOut}
            />
          );
        } else {
          return (
            //@ts-ignore
            <GenericDashboard
              location={this.props.location}
              profileData={this.props.profileData}
              onLogOut={this.props.onLogOut}
              properties={properties}
            />
          );
        }
      }
      case MAIN_TYPES.PRE_USE_INSPECTION: {
        if (
          properties.category &&
          properties.category.label &&
          properties.category.label.toLowerCase().includes("equipment") &&
          properties.equipment &&
          properties.equipment.name &&
          properties.equipment.name.toLowerCase().includes("lhd")
        ) {
          return (
            //@ts-ignore
            <PreUseInspectionDashboard
              location={this.props.location}
              profileData={this.props.profileData}
              onLogOut={this.props.onLogOut}
              title={"LHD"}
              type={DASHBOARD_TYPES.PRE_USE_INSPECTION_EQUIPMENT_LHD}
            />
          );
        } else {
          return (
            //@ts-ignore
            <GenericDashboard
              location={this.props.location}
              profileData={this.props.profileData}
              onLogOut={this.props.onLogOut}
              properties={properties}
            />
          );
        }
      }
      case MAIN_TYPES.WORK_FLOW: {
        return (
          //@ts-ignore
          <WorkflowInspectionDashboard
            location={this.props.location}
            profileData={this.props.profileData}
            onLogOut={this.props.onLogOut}
            title={"LHD"}
            properties={properties}
          />
        );
      }
      case MAIN_TYPES.WORKFLOW: {
        return (
          //@ts-ignore
          <WorkflowInspectionDashboard
            location={this.props.location}
            profileData={this.props.profileData}
            onLogOut={this.props.onLogOut}
            title={"LHD"}
            properties={properties}
          />
        );
      }
      case MAIN_TYPES.PRE_USE_INSPECTION_DASH: {
        if (properties.category.label.toLowerCase().includes("equipment")) {
          return (
            //@ts-ignore
            <PreUseInspectionDashboard
              location={this.props.location}
              profileData={this.props.profileData}
              onLogOut={this.props.onLogOut}
              title={"Conveyor Belt"}
              type={DASHBOARD_TYPES.PRE_USE_INSPECTION_EQUIPMENT_CONVEYOR_BELT}
            />
          );
        } else {
          return (
            //@ts-ignore
            <GenericDashboard
              location={this.props.location}
              profileData={this.props.profileData}
              onLogOut={this.props.onLogOut}
              properties={properties}
            />
          );
        }
      }
      case MAIN_TYPES.MACHINE_INSPECTION: {
        return (
          //@ts-ignore
          <GenericDashboard
            location={this.props.location}
            profileData={this.props.profileData}
            onLogOut={this.props.onLogOut}
            properties={properties}
          />
        );
      }
      default: {
        return (
          //@ts-ignore
          <GenericDashboard
            location={this.props.location}
            profileData={this.props.profileData}
            onLogOut={this.props.onLogOut}
            properties={properties}
          />
        );
      }
    }
  };

  render() {
    return <React.Fragment>{this.getDashboard()}</React.Fragment>;
  }
}
export default withStyles(styles)(MainDashboard);
